import './posterform.scss'

import React, {FunctionComponent, Ref} from 'react'

import {FormField} from '../formfield'
import {FormValues} from '../../pages'
import {Poster} from 'views/campagne/promo/poster'
import {PosterBuilder} from '../posterbuilder'
import {RegisterFormType} from 'campagne/types'
import {TeamCollected} from '../../../pages/team/TeamCollected'
import {Theme} from 'views/campagne/theme'
import {fromDisplayDateWithTime} from 'util/dates'
import {style} from 'util/campagne/style'
import {useFormikContext} from 'formik'
import {useTranslation} from 'util/i18n'

const styles = style('posterform')

type PosterFormType = {
	posterRef: Ref<SVGSVGElement>
}

export const PosterForm: FunctionComponent<
	PosterFormType &
		RegisterFormType & {
			editing?: string
			exportUrl?: string
			totalAmount?: number
		}
> = ({posterRef, affiche, editing, exportUrl, totalAmount}) => {
	const {values} = useFormikContext()
	const {
		affiche_with,
		affiche_what,
		affiche_where,
		location_name,
		date_start,
		date_end,
		hour_start,
		hour_end,
		date_has_end_hour,
		date_has_multiple_days
	} = values as FormValues
	const t = useTranslation('campagne').register
	return (
		<div class={styles}>
			<div class={styles('top')}>
				{editing && (
					<div class={styles('top-donations')}>
						<TeamCollected
							className={styles('sidebar-item')}
							price={totalAmount}
							exportUrl={exportUrl}
							title="Donaties aan deze actie"
						/>
					</div>
				)}
				<div class={styles('top-builder')}>
					<PosterBuilder
						organisation={affiche?.with_placeholder}
						isSharing={affiche?.what_placeholder}
						location={affiche?.where_placeholder}
						organisation_name={'affiche_with'}
						isSharing_name={'affiche_what'}
						location_name={'affiche_where'}
					/>
				</div>
				<div class={styles('top-poster')}>
					<div class={styles('top-poster-title')}>
						<Theme.H5>{affiche?.example}</Theme.H5>
					</div>
					<Poster
						organisation={
							affiche_with ? affiche_with : affiche?.with_placeholder
						}
						sharing={affiche_what ? affiche_what : affiche?.what_placeholder}
						location={
							affiche_where ? affiche_where : affiche?.where_placeholder
						}
						venue={location_name}
						start={fromDisplayDateWithTime(date_start, hour_start)}
						end={fromDisplayDateWithTime(
							date_has_multiple_days ? date_end : date_start,
							hour_end
						)}
						hasEndDate={date_has_multiple_days}
						hasEndHour={date_has_end_hour}
						ref={posterRef}
					/>
				</div>
			</div>
			<div class={styles('description')}>
				<FormField
					textarea
					name={'description_long'}
					label={t.textarea}
					placeholder={t.textarea_placeholder}
					info={t.max100}
				/>
			</div>
		</div>
	)
}
